import {PrintTemplateList} from './_models'

/** The designer of one template, of a new one, or of a copy of one. */
export const printStudioUrl = (companyId: number, template: number | 'new', copyOf?: number) =>
  `/apps/taxpayer-management/print-studio/${companyId}/${template}${
    copyOf ? `?copy=${copyOf}` : ''
  }`

/** Business settings › «قالب چاپ»: the business's print page and its templates. */
export const printTemplatesSettingsUrl = (companyId: number) =>
  `/apps/taxpayer-management/setting/${companyId}/print`

/**
 * Where «ویرایشگر قالب چاپ» opens for this user: the default template when they may edit it, else
 * the first one they may edit, a new template when the business has none, and otherwise the list
 * of templates to choose from. Null when the user may not edit templates.
 */
export const printStudioEntryUrl = (list: PrintTemplateList): string | null => {
  if (!list.canManage) return null
  const target =
    list.templates.find((template) => template.isDefault && template.canEdit) ||
    list.templates.find((template) => template.canEdit)
  if (target) return printStudioUrl(list.companyId, target.id)
  if (list.templates.length === 0) return printStudioUrl(list.companyId, 'new')
  return printTemplatesSettingsUrl(list.companyId)
}
